<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<div class="pa-5 ">
			<div>
				<v-row class="justify-center">
					<v-col cols="12">
						<v-form ref="formSearch" @submit.prevent="searchCustomer">
							<div class="mb-4 mt-4">
								ابتدا مشتری مورد نظر را جستجو کنید:
								<div><small class="grey--text">(جستجو میتواند بر اساس نام و نام خانوادگی، کدملی، شماره کارت، شماره موبایل باشد)</small></div>
							</div>
							<v-text-field class="" dense outlined v-model="searchPhrase" maxlength="10" label="اطلاعات مورد نظر را وارد کنید:" :error-messages="errorMessages" :rules="[() => !!searchPhrase || 'اطلاعات را وارد کنید']" required>
								<template v-slot:append-outer>
									<v-btn color="secondary" class="mt-n2" type="submit" :loading="searchLoading" fab small elevation="2" height="34" width="34">
										<v-icon>mdi-magnify</v-icon>
									</v-btn>
								</template>
							</v-text-field>
							<v-alert class="mb-2 mt-2 py-1" type="error" outlined v-if="searchMessage"><small>{{ searchMessage }}</small></v-alert>
							<div class="mb-2 mt-2 py-1" style="max-height: 200px;overflow-y: auto;">
								<div v-for="memberLoan in memberLoans" :key="memberLoan.member.id" class="pa-2 d-flex align-center" :class="{'info--text': selectedMemberLoan && selectedMemberLoan.member.id === memberLoan.member.id}" style="border-bottom: 1px dashed #ddd;">
									<small class="ml-3">نام: {{ memberLoan.member.fullName }}</small>
									&nbsp;
									<small class="ml-3">کد ملی: {{ memberLoan.member.nationalCode }}</small>
									&nbsp;
									<small class="ml-3">موبایل: {{ memberLoan.member.mobile }}</small>
									<v-btn x-small color="secondary" @click="() => {selectedUserLoan = null;selectedUserLoanPayment = null;selectedMemberLoan = memberLoan}">انتخاب</v-btn>
								</div>
							</div>
						</v-form>
					</v-col>
				</v-row>
				<v-form ref="formPayment" @submit.prevent="submitPayment">
					<v-row>
						<v-col cols="12" v-if="selectedMemberLoan && selectedMemberLoan.member && selectedMemberLoan.member.id !== 0">
							<div class="mb-1">وام:</div>
							<v-select :items="userLoans" v-model="selectedUserLoan" return-object dense :error-messages="errorMessages" :rules="[(val) => !!val || 'وام را انتخاب کنید']" item-text="title" item-value="id" />
						</v-col>
						<v-col cols="12" v-if="selectedMemberLoan && selectedMemberLoan.member && selectedMemberLoan.member.id !== 0">
							<div class="mb-1">قسط:</div>
							<v-select class="mb-3" :items="installments" v-model="selectedUserLoanPayment" return-object :error-messages="errorMessages" :rules="[(val) => !!val || 'قسط را انتخاب کنید']" dense item-text="title" item-value="id" />
							<v-text-money class="mb-3" dense v-model="price" :label="`:مبلغ را وارد کنید (حداکثر ${amount.toString().toPriceFormat()})`" :error-messages="errorMessages" :rules="[(val) => price <= amount || `مبلغ باید از ${amount.toString().toPriceFormat()} کمتر یا مساوی باشد`, (val) => price >= 0 || 'مبلغ صحیح نمی باشد']" required>
							</v-text-money>
							<div class="text-center">
								<v-btn color="secondary" type="submit" style="width: 150px;" small blocked class="mt-2" :loading="submitLoading">
									<v-icon class="ml-1" right>mdi-content-save-check-outline</v-icon>
									ثبت
								</v-btn>
							</div>
						</v-col>
					</v-row>
				</v-form>
			</div>
		</div>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'
	import { get } from 'vuex-pathify'
	import { cloneDeep } from 'lodash'

	export default {
		name: 'UnknownTransactionToPayment',
		props: {
			data: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				selectedMemberLoan: null,
				memberLoans: [],
				searchLoading: false,
				submitLoading: false,
				searchMessage: '',
				errorMessages: '',
				searchPhrase: '',				
				selectedUserLoan: null,
				selectedUserLoanPayment: null,
				price: 0
			}
		},
		computed: {
			...get('appSettings', [
				'settings',
			]),
			userLoans(){
				return (this.selectedMemberLoan?.userLoans || []).map(x => {
								x.title = `شماره وام: ${x.code}, عنوان وام: ${x.loanModel.title}, مبلغ خالص: ${x.amount.toString().toPriceFormat()}`
								return x
							})
			},
			installments() {
				return (this.selectedUserLoan?.loanPayments || []).map(x => {
					x.title = `شماره قسط: ${x.installmentNumber}, سررسید: ${x.targetMonth_Persian.date}, مبلغ قسط: ${x.installmentAmount.toString().toPriceFormat()}, واریزی تاکنون: ${x.sumAmount.toString().toPriceFormat()}`
					return x
				})
			},
			amount() {
				return this.data.isWithdraw ? this.data.credit : this.data.debit
			}
		},
		mounted() {
			this.price = this.amount
		},
		methods: {
			searchCustomer() {
				this.searchMessage = ''
				if (!this.$refs.formSearch.validate()) { return }

				this.searchLoading = true
				api.get('admin/member/Search2/' + this.searchPhrase, null)
					.then(
						response => {
							this.memberLoans = response
							if (!this.memberLoans.length)
								this.searchMessage = 'مشتری یافت نشد.'
						})
					.catch(err => {
						this.memberLoans = []
						this.searchMessage = err.message
					})
					.finally(() => this.searchLoading = false)
			},
			async submitPayment() {
				if (!this.$refs.formPayment.validate()) {
					toast.error('لطفا ابتدا تمام موارد فرم را تکمیل نمایید.')
					return
				}
				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از ثبت این عملیات مطمئن هستید؟',
				)) {
					let data = cloneDeep(this.selectedUserLoanPayment)
					let confirmSms = false
					if (this.settings.thanksPaymentSmsPattern) {
						confirmSms = await this.$refs.confirm.open(
							'توجه',
							'آیا مایل به ارسال پیامک ثبت قسط به مشتری هستید؟',
						)
					}
					data.sendSms = !!confirmSms
					if (data.amount === 0) {
						data.paymentMethod = 2
						data.saveDate = this.data.saveDate
						data.amount = this.price
						data.description = 'تبدیل از واریزی نامعلوم'
					} else {
						if (!data.loanPaymentOthers)
							data.loanPaymentOthers = []
						data.loanPaymentOthers.push({
							amount: this.price,
							paymentMethod: 2,
							targetMonth: data.targetMonth,
							saveDate: this.data.saveDate,
							description: 'تبدیل از واریزی نامعلوم'
						})
					}
					this.submitLoading = true
					api.post('admin/loanpayment/SubmitPayment', data)
						.then(
							response => {
								toast.success('صورتحساب با موفقیت ذخیره شد.')
								this.$emit('close')
							})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(x => {
							this.submitLoading = false
						})
				}
			},
		},
	}
</script>
<style></style>